// styles
import '@scss/main.scss'
// Main app component
import App from './App.vue'

// Vue
import { createApp } from 'vue'
import { router } from '@src/router'

import axios from 'axios'

// Plugins
import { createPinia } from 'pinia'
import VueApexCharts from 'vue3-apexcharts'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import MomentAdapter from '@date-io/moment'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as localeMessages from 'vuetify/locale'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { vuetifyColors } from '@scss/sds-design-system/color-shades'
import { aliases, fa } from 'vuetify/iconsets/fa'

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'

// Mapbox styles
import 'mapbox-gl/dist/mapbox-gl.css'

// i18n
import { getLanguageMixin, getVuetifyLocaleObject, createGettext } from '@src/utils/i18n'

// config
import { mapboxPublicKey } from '@src/config'
console.assert(mapboxPublicKey)

const app = createApp(App)
app.mixin(getLanguageMixin())
app.use(createPinia())
app.use(router)
app.component('Apexchart', VueApexCharts)
app.component('VueDatePicker', VueDatePicker)
app.component('FontAwesomeIcon', FontAwesomeIcon)
library.add(fas)

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common.Authorization = token
}

const vuetify = createVuetify({
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
  components,
  directives,
  date: {
    adapter: MomentAdapter,
  },
  theme: {
    defaultTheme: 'light',
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        dark: false,
        colors: vuetifyColors,
      },
    },
  },
  icons: {
    defaultSet: 'fa',
    aliases,
    sets: {
      fa,
    },
  },
  locale: getVuetifyLocaleObject(localeMessages),
})
app.use(vuetify)

app.use(createGettext())

app.mount('#app')
